var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .immune {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke: #000;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Immune",
    transform: "translate(-23,-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "immune4",
    clipPath: "url(#clippath-immune)",
    id: "g15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "immune",
    x: 25.66,
    y: 30.34,
    width: 5.7399998,
    height: 2.55,
    rx: 1.24,
    ry: 1.24,
    transform: "rotate(48.79,28.523671,31.620787)",
    id: "rect14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "immune",
    d: "m 35.12,31.06 c -0.33,-0.83 -1,-1.69 -1.02,-1.71 l -2.28,-2.63 c -0.46,-0.53 -1.26,-0.59 -1.8,-0.13 -0.53,0.47 -0.58,1.27 -0.12,1.8 l 2.24,2.55 c 0,0 0.7,0.84 0.7,1.96 v 7.37 c 0,0.7 0.57,1.27 1.27,1.27 0.7,0 1.27,-0.57 1.27,-1.27 v -7.65 c 0,0 0.06,-0.74 -0.27,-1.57 z",
    id: "path14"
  })), /*#__PURE__*/React.createElement("line", {
    className: "immune",
    x1: 31.290001,
    y1: 29.59,
    x2: 32.900002,
    y2: 28.27,
    id: "line14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "immune",
    x1: 27.6,
    y1: 32.43,
    x2: 29.209999,
    y2: 31.120001,
    id: "line15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9",
    clipPath: "url(#clippath-immune1)",
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "immune",
    x: 41.259998,
    y: 30.34,
    width: 5.7399998,
    height: 2.55,
    rx: 1.24,
    ry: 1.24,
    transform: "rotate(-48.79,44.133958,31.619822)",
    id: "rect15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "immune",
    d: "m 42.64,26.59 c -0.53,-0.46 -1.34,-0.41 -1.8,0.13 l -2.28,2.63 c 0,0 -0.69,0.88 -1.02,1.71 -0.33,0.83 -0.27,1.53 -0.27,1.57 v 7.65 c 0,0.7 0.57,1.27 1.27,1.27 0.7,0 1.27,-0.57 1.27,-1.27 v -7.37 c 0,-1.12 0.7,-1.96 0.7,-1.96 l 2.24,-2.55 c 0.46,-0.53 0.41,-1.33 -0.12,-1.8 z",
    id: "path15"
  })), /*#__PURE__*/React.createElement("line", {
    className: "immune",
    x1: 41.360001,
    y1: 29.59,
    x2: 39.75,
    y2: 28.27,
    id: "line16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "immune",
    x1: 45.049999,
    y1: 32.43,
    x2: 43.439999,
    y2: 31.120001,
    id: "line17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmune);
export default __webpack_public_path__ + "static/media/Immune.cffecbd7e1c411c374b947e4b81f8ee4.svg";
export { ForwardRef as ReactComponent };